import React from "react";
import "./PeopleAtCore.css";
import peopleImage from "../images/worker.jpg";

const PeopleAtCore = () => {
  return (
    <section className="people-section">
      <div className="people-container">

        <div className="people-image">
          <img
            src={peopleImage}
            alt="Factory Worker"
          />
        </div>

        <div className="people-content">
          <h2>
            PEOPLE AT THE <br /> CORE
          </h2>

          <div className="people-points">
            <div className="point">
              <span>○</span>
              <p>
                We are a team of highly proficient designers,
                professionals, technicians and artisans
              </p>
            </div>

            <div className="point">
              <span>○</span>
              <p>
                We adopt a 360-degree approach for innovation,
                engaging all areas of our business to inspire
                creativity and learning
              </p>
            </div>

            <div className="point">
              <span>○</span>
              <p>
                With a highly valued and competent workforce of
                over 300 people, we believe in maintaining a
                workplace that is conducive to growth and wellbeing
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default PeopleAtCore;